import { Helmet } from 'react-helmet';
import React from 'react';
import { useLanguage } from '../common/hooks';
import { useEffectivePlatformPortal } from 'src/PlatformPortal/hooks';
import { getPortalThemeTokens } from 'src/PlatformPortal/theme';

/**
 * Provider for setting the <head> metadata using `react-helmet`.
 */
export default function HelmetProvider() {
  const { language: lang } = useLanguage();
  const portal = useEffectivePlatformPortal();
  const tokens = getPortalThemeTokens(portal);

  return (
    <Helmet htmlAttributes={{ lang, translate: 'no' }}>
      {portal?.favicon?.url && <link rel="icon" href={portal.favicon.url} />}
      {tokens.fontCssUrl && <link rel="stylesheet" href={tokens.fontCssUrl} />}
    </Helmet>
  );
}
